import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import * as alertifyjs from 'alertifyjs';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-modal-type-product',
  templateUrl: './modal-type-product.component.html',
  styleUrls: ['./modal-type-product.component.css']
})
export class ModalTypeProductComponent implements OnInit {

  @Input()
  set abrirModal(value: boolean) {
    if (value) {
      this.loadProducts();
    }
    this._abrirModal = value;
  }
  get abrirModal(): boolean {
    return this._abrirModal;
  }
  private _abrirModal: boolean = false;

  @Input() selectedProductCode: string | null = null;

  @Output() codeAdded: EventEmitter<void> = new EventEmitter(); // Evento para notificar al padre
  @Output() productAdded: EventEmitter<void> = new EventEmitter(); // Evento para notificar al padre
  codesList:any[] = [];
  isModalOpen:boolean = false;
  selectedProduct: string = '0';
  productSelected:any;
  newCode:any = {code: '', name: '',description: '', insurance_product: null}
  formEmpty:any;
  globalError:boolean = false;

  // Productos de seguros
  insurerProducts: any[] = [];
  selectedInsuranceProduct: string = '';
  showInsuranceProductSelect: boolean = false;

  productArray:any[] = [];
  messageSelect:string = "0";

  constructor(
        private _user: UserService,
        private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadProducts();
    this.loadInsurerProducts();
  }

  private async loadProducts() {
    try {
      const consultProducts = await this._user.getTypesProductsInvoices();
      this.productArray = consultProducts.resp || [];
      
      // Auto-select product if selectedProductCode is provided
      if (this.selectedProductCode) {
        this.selectedProduct = this.selectedProductCode;
        this.productSelected = this.selectedProductCode;
        // Verificar si es producto de seguros
        await this.checkIfInsuranceProduct();
      } else {
        this.selectedProduct = '0';
      }
      
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error loading products:', error);
      this.productArray = [];
    }
  }

  private async loadInsurerProducts() {
    try {
      console.log('📦 Cargando productos de seguros...');
      const response = await this._user.getInsurerProducts();
      console.log('📦 Respuesta de productos de seguros:', response);
      
      if (response && response.resp && Array.isArray(response.resp)) {
        this.insurerProducts = response.resp;
      } else if (response && Array.isArray(response)) {
        this.insurerProducts = response;
      } else {
        this.insurerProducts = [];
      }
      
      console.log('✅ Productos de seguros cargados:', this.insurerProducts);
    } catch (error) {
      console.error('❌ Error loading insurer products:', error);
      this.insurerProducts = [];
    }
  }

  private async checkIfInsuranceProduct() {
    // Verificar si el producto seleccionado es de seguros
    try {
      if (this.productSelected) {
        const config = await this._user.getRemanenteNeteo(this.productSelected);
        console.log('🔍 Configuración del producto:', config);
        
        if (config && config.insurance && config.insurance.is_insurance_product) {
          this.showInsuranceProductSelect = true;
          console.log('✅ Producto de seguros detectado - mostrando select');
        } else {
          this.showInsuranceProductSelect = false;
          this.selectedInsuranceProduct = '';
          console.log('❌ Producto NO es de seguros - ocultando select');
        }
        
        this.cdr.detectChanges();
      }
    } catch (error) {
      console.error('Error checking insurance product:', error);
      this.showInsuranceProductSelect = false;
    }
  }

  async serviceCode() {
    try {
      debugger;

      if (!this.newCode.code || !this.newCode.name || !this.productSelected || this.selectedProduct === '0') {
        this.globalError = true;
        return;
      }

      let params: any = {
        code: this.productSelected,
        code_product: this.newCode.code.trim(),
        name: this.newCode.name.trim(),
        description: this.newCode.description.trim()
      };

      // Agregar producto de seguros si fue seleccionado
      if (this.showInsuranceProductSelect && this.selectedInsuranceProduct) {
        params.insurance_product = this.selectedInsuranceProduct;
        console.log('📋 Guardando con producto de seguros:', this.selectedInsuranceProduct);
      }

      console.log('📤 Enviando parámetros:', params);
      let insertCodeProduct = await this._user.setProductsInvoices(params);

      console.log(insertCodeProduct);

      if (insertCodeProduct) {
          alertifyjs.success(`Código del producto seleccionado agregado exitosamente`);
          await this.toggleModal();
          this.messageSelect = "0";
          this.codeAdded.emit();
        }

    } catch (error) {
      console.error('Error:', error);
      alertifyjs.error(`El código ya existe`);
    }
  }

  async toggleModal() {
    if (!this.abrirModal) {
      await this.loadProducts();
    }
    this.abrirModal = !this.abrirModal;
    this.resetForm();
  }

  resetForm(){
    this.newCode = {code: '', name: '', description: '', insurance_product: null}
    this.globalError = false;
    this.selectedProduct = '0';
    this.messageSelect = "0";
    this.selectedInsuranceProduct = '';
    this.showInsuranceProductSelect = false;
  }

  async selectProductInvoice(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.productSelected = target.value;
    // Verificar si es un producto de seguros
    await this.checkIfInsuranceProduct();
  }

  getProductName(productCode: string): string {
    const product = this.productArray.find(item => item?.params?.code === productCode);
    return product?.params?.name || '';
  }

}
